import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_THEME_API_URL
const SAMPLE_RESPONSE = {
  '13': {
    company_name: 'S.T.R.In.G',
    fy_list: ['2022-2023'],
    '2022-2023': {
      start_date: '2022-04-01',
      end_date: '2023-03-31',
    },
  },
  '72': {
    company_name: 'Test Company Private Limited',
    fy_list: ['2024-2025'],
    '2024-2025': {
      start_date: '2024-01-01',
      end_date: '2024-12-31',
    },
  },
  '73': {
    company_name: 'Testing 2',
    fy_list: ['2023-2024'],
    '2023-2024': {
      start_date: '2023-01-01',
      end_date: '2023-12-31',
    },
  },
}
interface FYDetails {
  start_date: string
  end_date: string
}

export interface CompanyInfo {
  company_name: string
  fy_list: string[]
  [fiscalYear: string]: FYDetails | string | string[]
}

export interface CompanyListResp {
  [cin: string]: CompanyInfo
}

export interface FYDetailsTransformed {
  startDate: string
  endDate: string
}

export interface CompanyTransformed {
  companyName: string
  fyList: string[]
  fyDetails: {
    [fiscalYear: string]: FYDetailsTransformed
  }
}

export interface CompanyListTransformedResp {
  [cin: string]: CompanyTransformed
}

export interface ErrorResponse {
  message: string
  status: string
}

const transformResponse = function (
  apiResponse: CompanyListResp | ErrorResponse
): CompanyListTransformedResp | ErrorResponse {
  if ('message' in apiResponse && 'status' in apiResponse) {
    return apiResponse as ErrorResponse
  }

  return Object.keys(apiResponse).reduce((result, cin) => {
    const company = apiResponse[cin]

    // Transform fiscal year details for all years in the list
    const fyDetails: {[fiscalYear: string]: FYDetailsTransformed} = {}

    // Process all keys in the company object to find all fiscal years with details
    Object.keys(company).forEach((key) => {
      // Skip non-fiscal year properties
      if (key === 'company_name' || key === 'fy_list') {
        return
      }

      const details = company[key]
      // Check if this is a FYDetails object
      if (
        details &&
        typeof details === 'object' &&
        'start_date' in details &&
        'end_date' in details
      ) {
        fyDetails[key] = {
          startDate: details.start_date,
          endDate: details.end_date,
        }
      }
    })

    // Create the transformed company object
    result[cin] = {
      companyName: company.company_name,
      fyList: company.fy_list,
      fyDetails: fyDetails,
    }

    return result
  }, {} as CompanyListTransformedResp)
}

export const getCompaniesList = async (): Promise<CompanyListTransformedResp | ErrorResponse> => {
  return await axios
    .get(`${API_URL}/company/list`, {
      validateStatus: () => true,
    })
    .then((d: AxiosResponse<CompanyListResp | ErrorResponse>) => d.data)
    .then((res) => {
      return transformResponse(res)
    })
}
